export default __webpack_public_path__ + "images/u_clock-seven.svg";